._1hoaym00 {
  display: flex;
  gap: 16px;
  justify-content: end;
  margin-top: 32px;
  flex-direction: column;
}
._1hoaym01 {
  font-weight: 700;
  margin-bottom: 16px;
}
._1hoaym02 {
  flex-grow: 1;
  flex-basis: 50%;
  justify-content: center;
}
._1hoaym02:is(._1hoaym02) {
  padding-bottom: 16px;
}
@media screen and (min-width: 768px) {
  ._1hoaym00 {
    flex-direction: row;
  }
}